import React, { useState } from "react";
import Packages from "./packages/Packages";
import { useIsMobile } from '../customHook/useIsMobile.js';

export default function ServiceSelector({
  onSkip,
  onServiceSelect,
  onGetHelpNow,
}) {
  const [showPackages, setShowPackages] = useState(false);
  const mobileWidth = useIsMobile(); 

  const services = [
    {
      icon: "./ServiceIcon1.svg",
      title: "Talk to Mindy Now",
      description: "Get instant, personalized support.",
      buttonText: "Start Talking",
      buttonColor: "bg-slate-400 hover:bg-slate-500",
    },
    {
      icon: "./ServiceIcon3.png",
      title: "Create a Wishlist",
      description: "Add items that will improve your college life.  ",
      buttonText: "Make a Wish",
      buttonColor: "bg-slate-400 hover:bg-slate-500",
    },
    {
      icon: "./giftboxlp.svg",
      title: "Send Some Love!",
      description: "Find the mindyKNOWS package just right for you.",
      buttonText: "Explore Ideas",
      buttonColor: "bg-slate-400 hover:bg-slate-500",
    },
  ];

  const handleServiceClick = (index) => {
    onServiceSelect && onServiceSelect(index);
  };

  return (
    <div
  style={{
    display: "flex",
    width: "100%",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    borderRadius: "20px",
    background: "url('/landingbg3.png') no-repeat center center / cover",
    boxShadow: "0 10px 25px 0 rgba(0, 10, 25, 0.08)",
    zIndex: 999,
    overflow: "hidden",
  }}
>

  <div
    style={{
      display: "flex",
      width: "100%",
      height: "100%", // fill parent
      justifyContent: "center",
      alignItems: "center",
      position: "relative", // changed from fixed
      borderRadius: "20px",
      background: "rgba(255, 255, 255, 0.15)",
      boxShadow: "0 10px 25px 0 rgba(0, 10, 25, 0.08)",
    }}
  >
    {/* Left Mindy Image */}
    <div
  style={{
    display: !mobileWidth ? "flex" : "none",
    width: "294.775px",
    height: "648.273px",
    flexShrink: 0,
    backgroundImage: "url('/mindyVM3.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",

    /* 👇 Subtle vibrancy */
    filter: "brightness(1.02) contrast(1.02) saturate(1.12)",
  }}
/>


    {/* Main Content */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "65px",
        padding: "30px 0",
        maxHeight: "90vh", // ensures content never exceeds viewport
      }}
    >
      {/* Header Text Container */}
      <div
        style={{
          width: "700px",
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginTop: !mobileWidth ? "0" : "30px",
          color: "#FFF",
        }}
      >
        <h1
          style={{
            fontFamily: "Manrope, sans-serif",
            fontSize: "28px",
            fontWeight: "700",
            lineHeight: "120%",
            letterSpacing: "0.5px",
          }}
        >
          Let’s Make College Awesome.
        </h1>
        <p
          style={{
            fontFamily: "Manrope, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "120%",
            letterSpacing: "-0.3px",
            marginTop: "4px",
          }}
        >
          Select one of these options to launch your mindyKNOWS journey...
        </p>
      </div>

          {/* Cards Section */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: "36px",
              padding: !mobileWidth ? "2px 0" : "0",
            }}
          >
            {services.map((service, index) => (
              <div
                key={index}
                style={{
                  width: !mobileWidth ? "210px" : "265px",
                  padding: "16px",
                  background: "rgba(255, 255, 255, 0.15)",
                  borderRadius: "32px",
                  backdropFilter: "blur(30px)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "16px",
                  transition: "all 0.3s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                  e.currentTarget.style.transform = "scale(1.015)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      background: "transparent",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={service.icon}
                      alt="service-icon"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: "transparent",
                      }}
                    />
                  </div>
                  <h3
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      color: "white",
                      fontSize: "15px",
                      fontWeight: "700",
                      lineHeight: "120%",
                      letterSpacing: "-0.3px",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      fontWeight: "normal",
                      fontFamily: "Manrope, sans-serif",
                      lineHeight: "1.625",
                      opacity: 0.8,
                    }}
                  >
                    {service.description}
                  </p>
                </div>

                <button
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    background: service.buttonColor.includes("amber")
                      ? "#C05630"
                      : "#7EB3AB",
                    borderRadius: "16px",
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      service.buttonColor.includes("amber")
                        ? "#984628ff"
                        : "#6c9b94ff";
                    e.currentTarget.style.boxShadow =
                      "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      service.buttonColor.includes("amber")
                        ? "#C05630"
                        : "#7EB3AB";
                    e.currentTarget.style.boxShadow =
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "scale(0.95)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                  onClick={() => handleServiceClick(index)}
                >
                  <span
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      color: "white",
                      fontSize: "15px",
                      fontWeight: "700",
                      lineHeight: "1.25",
                    }}
                  >
                    {service.buttonText}
                  </span>
                </button>
              </div>
            ))}
          </div>

          {/* Footer Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // align right
                alignItems: "center",
                gap: "14px",
                marginTop: "-100px",
                width: "100%", // make full width so flex-end works
                paddingRight: !mobileWidth ? "30px" : "10px", // optional padding from right edge
              }}
            >
            {/* <button
              style={{
                background: "transparent",
                border: "none",
                color: "#FFF",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "120%",
                letterSpacing: "-0.3px",
                cursor: "pointer",
              }}
              onClick={onSkip}
            >
              Skip for now
            </button> */}
            <img
              src="/mindylogo2.svg"
              alt="mindy logo"
              style={{
                width: "250px",
                height: "200px",
                objectFit: "contain",
                marginRight: !mobileWidth ? "-25px" : "-10px", //  move logo slightly right
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
